import * as React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import AppStore from './store';
import Amplify, { Auth } from 'aws-amplify';
import axios, { AxiosResponse } from 'axios';
import { logout } from './store/reducers/authSlice';
import { get } from 'lodash';
import showNotification from './components/Notification';

axios.interceptors.request.use(function (config) {
  return new Promise((resolve, reject) => {
    Auth.currentSession()
      .then((session) => {
        const idTokenExpire = session.getIdToken().getExpiration();
        const refreshToken = session.getRefreshToken();
        const currentTimeSeconds = Math.round(+new Date() / 1000);
        if (idTokenExpire < currentTimeSeconds) {
          Auth.currentAuthenticatedUser().then((res) => {
            res.refreshSession(refreshToken, (err: any, data: any) => {
              if (err) {
                // exipire and cant refresh
                AppStore.store.dispatch(logout());
                reject(err);
              } else {
                config.headers.Authorization = `Bearer ${data
                  .getIdToken()
                  .getJwtToken()}`;
                resolve(config);
              }
            });
          });
        } else {
          config.headers.Authorization = `Bearer ${session
            .getIdToken()
            .getJwtToken()}`;
          resolve(config);
        }
      })
      .catch(() => {
        // another errors like 404, internet etc
        resolve(config);
      });
  });
});

axios.interceptors.response.use(
  (response: AxiosResponse<any>) => Promise.resolve(response),
  function (error) {
    const errorCode = get(error, 'response.status', 0);
    if (errorCode === 403) {
      showNotification({
        type: 'error',
        message:
          'You are not authorized to view this page. Please contact the site administrator',
      });
    }
    return Promise.reject(error);
  },
);

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: 'us-east-1',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'us-east-1_0R2g1HtRJ',

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: '52d5dabh3fr6mgogpepi2gkn3g',

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: 'USER_PASSWORD_AUTH',

    // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
    clientMetadata: { appId: 'works.wealthie.admin' },

    // OPTIONAL - Hosted UI configuration
    oauth: {},
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={AppStore.store}>
      <PersistGate loading={null} persistor={AppStore.persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
